import React, { useEffect, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import {Filter} from '@progress/kendo-react-data-tools';
import classes from './KendoFilterGridModal.module.css';

const styles = (theme) => ({
    root: {
        margin:  0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right:    theme.spacing(1),
        top:      theme.spacing(1),
        color:    theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h5">{children}</Typography>
            {
                onClose ? (
                    <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                ) : null
            }
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2)
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin:  0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);

const defaultFilter = {
    logic:   'and',
    filters: []
};

const KendoFilterGridModal = props => {
    const {fields, filter, setAppliedFilter, setFilter, title} = props;

    const [filterValue, setFilterValue] = useState(filter === null ? defaultFilter : filter);

    useEffect(() => {
        return () => {
            setFilterValue(defaultFilter);
        };
    }, []);

    useEffect(() => {
        setFilterValue(filter === undefined || filter === null || filter.filters?.length === 0 ? defaultFilter : filter);
    }, [filter]);

    const handleClose = () => {
        setFilter(filterValue);
        if (setAppliedFilter) {
            setAppliedFilter(filterValue);
        }
        props.setFilterModalOpen(false);
        setFilterValue(defaultFilter);
    };

    const handleCancel = () => {
        props.setFilterModalOpen(false);
    };

    const onFilterChange = event => {
        setFilterValue(event.filter);
    };

    return (
        <div className={classes.Dialog}>
            <style>
                {`
                    .MuiDialog-paperWidthSm { 
                        max-width: 1200px; 
                    }
                    .k-dropdown { 
                        font-size: 1.3rem !important 
                    }
                    .k-selected { 
                        background-color: #d0021b !important; 
                        color: white !important; 
                    }
                    .k-input-value-text {
                        font-size: 1.3rem;
                    }
                    .k-toolbar .k-input, .k-toolbar .k-picker {
                        width: 20em;
                    }                    
                    .k-filter .k-filter-operator .k-dropdown-list, .k-filter .k-filter-operator .k-dropdown, .k-filter .k-filter-operator .k-dropdownlist {
                        width: 20em;
                    }                
                    `
                }
            </style>
            <Dialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={props.filterModalOpen}
                scroll="paper"
            >
                <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                    {title ? title : 'Grid Filter'}
                </DialogTitle>
                <DialogContent dividers>
                    <div>
                        <Filter
                            value={filterValue}
                            style={{minWidth: '950px', width: '50vw', height: '500px'}}
                            onChange={onFilterChange}
                            fields={fields.filter(item => !item.actionCell || item.name)}
                        />
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button className={classes.Button} onClick={handleClose} disableRipple>
                        Apply
                    </Button>
                    <Button className={classes.Button} onClick={handleCancel} disableRipple>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default (KendoFilterGridModal);
